import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { HttpClient } from '@angular/common/http';
import { RestBase } from '../rest.base';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthService } from '../auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class SmartlabService extends RestBase {

  public firstGetProjectsDone = false;
  public firstNavigationToSingleProjectDone = false;
  private cachedProjects = [];

  constructor(private http: HttpClient,
    private _authService: AuthService) { super(environment.apiUrl + `v1/smartlab/`); }

  getProjects(userId: string) {
    return new Promise<any>((resolve, reject) => {

      if (!this.firstGetProjectsDone) {
        this.http.get(this.endpoint + encodeURIComponent(userId) + '/projects')
          .pipe(map(this.extractData), catchError(this.handleError)).toPromise()
          .then(result => {
            this.firstGetProjectsDone = true;
            this.cachedProjects = result as Array<any>;
            console.log(`cached projects: `, this.cachedProjects);
            resolve(result);
          })
          .catch(err => {
            reject(err);
          });
      } else {
        resolve(this.cachedProjects);
      }
    });
  }

  getPFDForProject(projectCode: string): Observable<any> {
    return this.http.get(this.endpoint + 'pfd/' + projectCode)
      .pipe(map(this.extractData), catchError(this.handleError));
  }

  getProject(projectCode: string) {
    return new Observable<any>((observer) => {
      this.getProjectAfterFirstProjectsDone(observer, projectCode);
    });
  }

  private getProjectAfterFirstProjectsDone(observer, projectCode) {
    if (this.firstGetProjectsDone === true) {
      var project = this.cachedProjects.find(x => x.code == projectCode);
      if (project == null) {
        observer.error('Project does not exist');
      } else {
        // console.log(`getProject: `, this.cachedProjects);
        observer.next(project);
      }
      observer.complete();
    } else {
      setTimeout(() => {
        this.getProjectAfterFirstProjectsDone(observer, projectCode)
      }, 500);
    }
  }

  async getCumulioTokenForDashboard(projectCode: string, dashboardId: string, tags?: string,  blocks?: string) {

    console.log(`getCumulioTokenForDashboard projectCode:`, projectCode);
    console.log(`getCumulioTokenForDashboard dashboardId:`, dashboardId);
    const userId = this._authService.getUserProfile()[`sub`];

    var requestEndpoint = this.endpoint + userId + '/cumuliotoken/' + projectCode + ``;
    var requestEndpoint = `${this.endpoint}${userId}/cumuliotoken/${projectCode}/${dashboardId}`;

    var hasBlocks = false;

    if (blocks != null && blocks !== ``) {
      hasBlocks = true;
      console.log(`blocks:`, blocks);
      var splitBlocks = blocks.split(',');

      var first = true;

      splitBlocks.forEach(block => {
        requestEndpoint = first ? `${requestEndpoint}?filterBlock=${block}` : `${requestEndpoint}&filterBlock=${block}`;
        first = false;
      });
    }

    if (tags != null && tags !== ``) {
      console.log(`tags:`, tags);
      var splitTags = blocks.split(',');

      var first = true;

      splitTags.forEach(block => {
        requestEndpoint = first && !hasBlocks ? `${requestEndpoint}?filterTag=${block}` : `${requestEndpoint}&filterTag=${block}`;
        first = false;
      });
    }
    

    return new Promise<any>((resolve, reject) => {
      this.http.get(requestEndpoint)
        .pipe(map(this.extractData), catchError(this.handleError)).toPromise()
        .then(result => {
          resolve(result);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
